import { Routes } from '@angular/router';
import { ProductSearchComponent } from './pages/product-search/product-search.component';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { CreateProductComponent } from './pages/create-product/create-product.component';
import { UpdateProductComponent } from './pages/update-product/update-product.component';
import { QuoteCreateQuickComponent } from './pages/quote-create-quick/quote-create-quick.component';
import { QuoteUpdateComponent } from './pages/quote-update/quote-update.component';
import { QuoteSearchComponent } from './pages/quote-search/quote-search.component';
import { QuoteViewComponent } from './pages/quote-view/quote-view.component';
import { ProductTypeSelectComponent } from './pages/product-type-select/product-type-select.component';
import { ProfileManageComponent } from './pages/profile-manage/profile-manage.component';
import { ProductPriceEditorComponent } from './pages/product-price/product-price.component';
import { DealDeskSearchComponent } from './pages/deal-desk-search/deal-desk-search.component';
import { DealDeskCreateComponent } from './pages/deal-desk-create/deal-desk-create.component';
import { DealDeskViewComponent } from './pages/deal-desk-view/deal-desk-view.component';
import { ReportsComponent } from './pages/reports/reports.component';

export const routes: Routes = [
    {
        title: "Home",
        path: "",
        component: HomePageComponent
    },
    {
        title: "Error",
        path: "error",
        component: HomePageComponent
    },
    {
        title: "Profile",
        path: "profile",
        component: ProfileManageComponent,
    },
    {
        title: "Product Search",
        path: "product-search/:type",
        component: ProductSearchComponent,
    },
    {
        title: "New Product",
        path: "product-create/:type",
        component: CreateProductComponent
    },
    {
        title: "Product Update",
        path: "product-update/:id",
        component: UpdateProductComponent
    },
    {
        title: "Product Price",
        path: "product-price/:id",
        component: ProductPriceEditorComponent
    },
    {
        title: "Select Product",
        path: "product-type-select",
        component: ProductTypeSelectComponent
    },
    {
        title: "New Quote",
        path: "quote-create-quick",
        component: QuoteCreateQuickComponent
    },
    {
        title: "Update Quote",
        path: "quote-update/:quoteId",
        component: QuoteUpdateComponent
    },
    {
        title: "Quote Search",
        path: "quote-search",
        component: QuoteSearchComponent
    },
    {
        title: "View Quote",
        path: "quote-view/:quoteId",
        component: QuoteViewComponent
    },
    {
        title: "Deal Desk",
        path: "deal-desk",
        component: DealDeskSearchComponent
    },
    {
        title: "New Deal Desk Request",
        path: "deal-desk-create",
        component: DealDeskCreateComponent
    },
    {
        title: "View Deal Desk Request",
        path: "deal-desk-view/:dealDeskId",
        component: DealDeskViewComponent
    },
    {
        title: "Reports",
        path: "reports",
        component: ReportsComponent
    }
];
